module.exports = __webpack_public_path__ + "static/img/cas.5348f42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cas.png
// module id = ILGs
// module chunks = 22